import { render, staticRenderFns } from "./channel-chart.vue?vue&type=template&id=1934e77a&scoped=true&"
import script from "./channel-chart.vue?vue&type=script&lang=js&"
export * from "./channel-chart.vue?vue&type=script&lang=js&"
import style0 from "./channel-chart.vue?vue&type=style&index=0&id=1934e77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934e77a",
  null
  
)

export default component.exports